import { Component, Input, Output, EventEmitter, HostBinding } from '@angular/core';

@Component({
  selector: 'app-primary-button',
  template: `
    <app-button
      variant="primary"
      [labelText]="labelText || label"
      [size]="size"
      [loading]="loading"
      [disabled]="disabled"
      [fullWidth]="fullWidth"
      [width]="width"
      [minWidth]="minWidth"
      [maxWidth]="maxWidth"
      [type]="type"
      [startIcon]="startIcon"
      [endIcon]="endIcon"
      [customClass]="customClass"
      (btnClick)="btnClick.emit($event)"
    >
      <ng-content></ng-content>
    </app-button>
  `,
  styles: [
    `
      :host {
        display: block;
      }
      :host.inline,
      :host.inline-block {
        display: inline-block;
      }
    `,
  ],
})
export class AppPrimaryButtonComponent {
  @Input() labelText: string = '';
  @Input() label: string = '';
  @Input() size: 'large' | 'medium' | 'small' | 'compact' = 'medium';
  @Input() loading: boolean = false;
  @Input() disabled: boolean = false;
  @Input() fullWidth: boolean = false;
  @Input() width: string = '';
  @Input() minWidth: string = '';
  @Input() maxWidth: string = '';
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() startIcon: string = '';
  @Input() endIcon: string = '';
  @Input() customClass: string = '';

  @Output() btnClick = new EventEmitter<MouseEvent>();

  @HostBinding('style.width') get hostWidth() {
    if (this.width) return this.width;
    return this.fullWidth ? '100%' : null;
  }
  @HostBinding('style.minWidth') get hostMinWidth() {
    return this.minWidth || null;
  }
  @HostBinding('style.maxWidth') get hostMaxWidth() {
    return this.maxWidth || null;
  }
  @HostBinding('style.display') get hostDisplay() {
    return this.fullWidth ? 'block' : 'inline-block';
  }
  @HostBinding('class.w-100') get hostW100() {
    return this.fullWidth;
  }
  @HostBinding('style.pointerEvents') get hostPointerEvents() {
    return this.disabled ? 'none' : null;
  }
}
